
















import Vue from 'vue'
import BaseSection from '@/components/Typography/UiPreviewSection/BaseSection.vue'

export default Vue.extend({
  components: {
    BaseSection
  },
  props: {
    resource: {
      type: Object,
      required: true
    }
  }
})
